import { useCallback, useEffect, useState } from 'react'

const useFetchData = (request, deps = []) => {
  const [data, setData] = useState({})

  const fetchData = useCallback(
    () =>
      request()
        .then(response => setData(response.data))
        .catch(error => {
          console.error(error)
          setData({ data: null })
        }),
    [request]
  )

  useEffect(() => {
    fetchData()
  }, deps)

  return { data, refetch: fetchData }
}

export default useFetchData
